import FormattedMessage from 'I18n/components/FormattedMessage';
import { ENTERPRISE } from 'pricing-pages-ui/constants/routing/Tabs';
import { useSelector } from 'react-redux';
// @ts-expect-error image import
import WHEEL from 'bender-url!../../img/splash-page/ConnectedCustomerPlatform_Graphic_2x.webp';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { useIsMobile } from 'pricing-pages-lib/context/IsMobileContext';
import { PageSection, SectionContainer, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from '../../components/common/SignupButton';
import { SPLASH_PAGE_CARD } from '../../constants/tracking/TrackingSources';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PowerOfHubSpotSection = ({
  sourceId,
  selectedTab = ENTERPRISE
}) => {
  const isInApp = useSelector(isAppAuthSelector);
  const imageToShow = WHEEL;
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx(SectionContainer, {
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1300",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(SectionTitle, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "splash-page.powerOfHubSpot.title"
            })
          }), /*#__PURE__*/_jsx(SectionSubTitle, {
            textAlign: "left",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `splash-page.powerOfHubSpot.description.${selectedTab}`
            })
          }), !isInApp && /*#__PURE__*/_jsx(View, {
            marginBlockStart: "800",
            children: /*#__PURE__*/_jsx(SignupButton, {
              use: "primary",
              productLine: "crm",
              sourceId: sourceId,
              trackingSource: SPLASH_PAGE_CARD
            })
          })]
        }), isMobile ? null : /*#__PURE__*/_jsx(Image, {
          src: imageToShow,
          maxInlineSize: "50%",
          role: "img"
        })]
      })
    })
  });
};
export default PowerOfHubSpotSection;